// Owner: ai-client (wave 1), copilot-panel (wave 2). The inline-AI target of an editor, for `<AskAiButton>`
// in the editor's top bar: inside a provider the button opens inline AI at the caret; outside it opens the
// Copilot panel. Light module (no run machinery), so top bars can import it.
import { createContext, useContext } from 'react';

export type InlineAiTarget = {
  /** Open the inline prompt bar at the editor's caret or selection. */
  open: (prompt?: string) => void;
  /** Whether inline AI can open now (the editor is mounted and AI is ready). */
  enabled: boolean;
};

export const InlineAiContext = createContext<InlineAiTarget | null>(null);

export const InlineAiProvider = InlineAiContext.Provider;

export function useInlineAiTarget(): InlineAiTarget | null {
  return useContext(InlineAiContext);
}
